/*
  AI optimizer: confirm, apply exactly the previewed weights, undo. Merged
  FIRST into TRANSLATION_MAPS in ./index.js, so existing translations still
  win. Keys are the English source.
*/

const ru = {
  "Settings changed — run the preview again before applying.": "Настройки изменились — перед применением снова запустите предпросмотр.",
  "Undo: return the previous weights": "Отменить: вернуть прежние веса",
  "Previous weights are back": "Прежние веса возвращены",
  "Could not restore the previous weights": "Не удалось вернуть прежние веса",
  "Change stream weights now?": "Изменить веса потоков сейчас?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "Новые веса начнут действовать для работающих потоков со следующего клика. Отменить изменение можно на этой странице.",
};

const es = {
  "Settings changed — run the preview again before applying.": "La configuración cambió: vuelve a ejecutar la vista previa antes de aplicar.",
  "Undo: return the previous weights": "Deshacer: volver a los pesos anteriores",
  "Previous weights are back": "Se restauraron los pesos anteriores",
  "Could not restore the previous weights": "No se pudieron restaurar los pesos anteriores",
  "Change stream weights now?": "¿Cambiar ahora los pesos de los flujos?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "Los nuevos pesos se aplican a los flujos activos desde el siguiente clic. Puedes deshacerlo en esta página.",
};

const pt = {
  "Settings changed — run the preview again before applying.": "As configurações mudaram — execute a pré-visualização novamente antes de aplicar.",
  "Undo: return the previous weights": "Desfazer: voltar aos pesos anteriores",
  "Previous weights are back": "Os pesos anteriores foram restaurados",
  "Could not restore the previous weights": "Não foi possível restaurar os pesos anteriores",
  "Change stream weights now?": "Alterar agora os pesos dos fluxos?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "Os novos pesos valem para os fluxos ativos a partir do próximo clique. Você pode desfazer nesta página.",
};

const de = {
  "Settings changed — run the preview again before applying.": "Die Einstellungen haben sich geändert — starte die Vorschau erneut, bevor du anwendest.",
  "Undo: return the previous weights": "Rückgängig: vorherige Gewichte wiederherstellen",
  "Previous weights are back": "Die vorherigen Gewichte sind wiederhergestellt",
  "Could not restore the previous weights": "Die vorherigen Gewichte konnten nicht wiederhergestellt werden",
  "Change stream weights now?": "Gewichte der Streams jetzt ändern?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "Die neuen Gewichte gelten für laufende Streams ab dem nächsten Klick. Du kannst das auf dieser Seite rückgängig machen.",
};

const fr = {
  "Settings changed — run the preview again before applying.": "Les paramètres ont changé — relancez l’aperçu avant d’appliquer.",
  "Undo: return the previous weights": "Annuler : revenir aux poids précédents",
  "Previous weights are back": "Les poids précédents sont rétablis",
  "Could not restore the previous weights": "Impossible de rétablir les poids précédents",
  "Change stream weights now?": "Modifier maintenant les poids des flux ?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "Les nouveaux poids s’appliquent aux flux actifs dès le prochain clic. Vous pouvez annuler sur cette page.",
};

const it = {
  "Settings changed — run the preview again before applying.": "Le impostazioni sono cambiate: esegui di nuovo l’anteprima prima di applicare.",
  "Undo: return the previous weights": "Annulla: ripristina i pesi precedenti",
  "Previous weights are back": "I pesi precedenti sono stati ripristinati",
  "Could not restore the previous weights": "Impossibile ripristinare i pesi precedenti",
  "Change stream weights now?": "Modificare ora i pesi dei flussi?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "I nuovi pesi valgono per i flussi attivi dal clic successivo. Puoi annullare su questa pagina.",
};

const pl = {
  "Settings changed — run the preview again before applying.": "Ustawienia się zmieniły — uruchom podgląd ponownie przed zastosowaniem.",
  "Undo: return the previous weights": "Cofnij: przywróć poprzednie wagi",
  "Previous weights are back": "Przywrócono poprzednie wagi",
  "Could not restore the previous weights": "Nie udało się przywrócić poprzednich wag",
  "Change stream weights now?": "Zmienić teraz wagi strumieni?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "Nowe wagi obowiązują dla działających strumieni od następnego kliknięcia. Możesz to cofnąć na tej stronie.",
};

const tr = {
  "Settings changed — run the preview again before applying.": "Ayarlar değişti — uygulamadan önce önizlemeyi yeniden çalıştırın.",
  "Undo: return the previous weights": "Geri al: önceki ağırlıklara dön",
  "Previous weights are back": "Önceki ağırlıklar geri yüklendi",
  "Could not restore the previous weights": "Önceki ağırlıklar geri yüklenemedi",
  "Change stream weights now?": "Akış ağırlıkları şimdi değiştirilsin mi?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "Yeni ağırlıklar çalışan akışlara bir sonraki tıklamadan itibaren uygulanır. Bunu bu sayfada geri alabilirsiniz.",
};

const uk = {
  "Settings changed — run the preview again before applying.": "Налаштування змінилися — перед застосуванням знову запустіть попередній перегляд.",
  "Undo: return the previous weights": "Скасувати: повернути попередні ваги",
  "Previous weights are back": "Попередні ваги повернуто",
  "Could not restore the previous weights": "Не вдалося повернути попередні ваги",
  "Change stream weights now?": "Змінити ваги потоків зараз?",
  "The new weights apply to running streams from the next click. You can undo this on this page.": "Нові ваги почнуть діяти для робочих потоків з наступного кліку. Скасувати зміну можна на цій сторінці.",
};

const AI_OPTIMIZER_SAFE = { ru, es, pt, de, fr, it, pl, tr, uk };
export default AI_OPTIMIZER_SAFE;
